var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import cx from "classnames";
import * as React from "react";
import React__default, { useEffect, useRef, useState, useCallback, useContext } from "react";
import { ethers } from "ethers";
import { initializeConnector } from "@web3-react/core";
import { MetaMask } from "@web3-react/metamask";
import { Network } from "@web3-react/network";
import { WalletConnect } from "@web3-react/walletconnect";
var Button$1 = "";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, g) {
  var b, d = {}, e = null, h = null;
  g !== void 0 && (e = "" + g);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (h = a.ref);
  for (b in a)
    m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
}
reactJsxRuntime_production_min.Fragment = l;
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const Button = (_a) => {
  var _b = _a, {
    variant,
    className,
    children,
    onClick
  } = _b, rest = __objRest(_b, [
    "variant",
    "className",
    "children",
    "onClick"
  ]);
  return /* @__PURE__ */ jsx("button", __spreadProps(__spreadValues({
    onClick,
    className: cx([variant && `walletlink-btn-${variant}`, className])
  }, rest), {
    children
  }));
};
const jsonRPCProviderKeys = {
  infuraKey: { "GITHUB_STATE": "/home/runner/work/_temp/_runner_file_commands/save_state_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies__types_node": "^17.0.25", "npm_package_exports___require": "./dist/index.umd.js", "STATS_TRP": "true", "DEPLOYMENT_BASEPATH": "/opt/runner", "DOTNET_NOLOGO": "1", "npm_package_devDependencies_vitest": "^0.10.0", "USER": "runner", "npm_package_devDependencies__testing_library_jest_dom": "^5.16.4", "npm_package_devDependencies__esbuild_plugins_node_globals_polyfill": "^0.1.1", "npm_config_version_commit_hooks": "true", "npm_config_user_agent": "yarn/1.22.19 npm/? node/v14.21.3 linux x64", "npm_config_always_auth": "", "CI": "true", "npm_package_devDependencies__testing_library_user_event": "^14.1.1", "npm_package_scripts_architecture": "depcruise -x node_modules --ts-config --output-type dot src lib | dot -T svg > dependencygraph.svg", "npm_config_bin_links": "true", "GITHUB_ENV": "/home/runner/work/_temp/_runner_file_commands/set_env_0f6c46a6-0341-4655-9e92-ee42d766a9df", "PIPX_HOME": "/opt/pipx", "npm_node_execpath": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "npm_package_devDependencies_vite": "^2.9.5", "npm_package_dependencies__walletconnect_ethereum_provider": "^1.7.8", "npm_config_init_version": "1.0.0", "JAVA_HOME_8_X64": "/usr/lib/jvm/temurin-8-jdk-amd64", "NODE_AUTH_TOKEN": "XXXXX-XXXXX-XXXXX-XXXXX", "SHLVL": "1", "npm_package_peerDependencies_react": ">=16.8", "npm_package_files_0": "dist", "HOME": "/home/runner", "npm_package_devDependencies__typescript_eslint_parser": "^5.21.0", "npm_package_dependencies_ethers": "^5.6.4", "RUNNER_TEMP": "/home/runner/work/_temp", "GITHUB_EVENT_PATH": "/home/runner/work/_temp/_github_workflow/event.json", "npm_package_devDependencies_eslint_config_prettier": "^8.5.0", "npm_package_devDependencies__testing_library_react_hooks": "^8.0.0", "JAVA_HOME_11_X64": "/usr/lib/jvm/temurin-11-jdk-amd64", "PIPX_BIN_DIR": "/opt/pipx_bin", "GITHUB_REPOSITORY_OWNER": "coinlist", "npm_config_init_license": "MIT", "GRADLE_HOME": "/usr/share/gradle-8.1.1", "ANDROID_NDK_LATEST_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "STATS_RDCL": "true", "GITHUB_RETENTION_DAYS": "30", "YARN_WRAP_OUTPUT": "false", "npm_package_dependencies__web3_react_types": "8.0.16-beta.0", "npm_config_version_tag_prefix": "v", "GITHUB_REPOSITORY_OWNER_ID": "31194466", "POWERSHELL_DISTRIBUTION_CHANNEL": "GitHub-Actions-ubuntu22", "AZURE_EXTENSION_DIR": "/opt/az/azcliextensions", "GITHUB_HEAD_REF": "", "npm_package_devDependencies_vite_plugin_dts": "^1.1.0", "npm_package_exports___dist_style_css": "./dist/style.css", "npm_config_userconfig": "/home/runner/work/_temp/.npmrc", "SYSTEMD_EXEC_PID": "679", "npm_package_devDependencies_husky": "^7.0.4", "npm_package_devDependencies_eslint_plugin_react_hooks": "^4.5.0", "npm_package_dependencies_analytics": "^0.8.1", "GITHUB_GRAPHQL_URL": "https://api.github.com/graphql", "npm_package_devDependencies_vite_plugin_svgr": "^1.1.0", "npm_package_devDependencies_typescript": "^4.6.3", "npm_package_devDependencies_tailwindcss": "^3.0.24", "npm_package_description": "A standalone module that is responsible for providing web3 wallets interactions for CoinList users.", "GOROOT_1_20_X64": "/opt/hostedtoolcache/go/1.20.4/x64", "NVM_DIR": "/home/runner/.nvm", "npm_package_readmeFilename": "README.md", "npm_package_devDependencies_react": "^18.0.0", "npm_package_devDependencies__types_react_dom": "^18.0.0", "npm_package_types": "./dist/index.d.ts", "npm_package_homepage": "https://github.com/coinlist/wallet-link#readme", "DOTNET_SKIP_FIRST_TIME_EXPERIENCE": "1", "JAVA_HOME_17_X64": "/usr/lib/jvm/temurin-17-jdk-amd64", "ImageVersion": "20230507.1", "npm_package_devDependencies_typescript_plugin_css_modules": "^3.4.0", "npm_package_devDependencies_prettier": "^2.6.2", "npm_package_scripts_dev": "vite", "RUNNER_OS": "Linux", "GITHUB_API_URL": "https://api.github.com", "SWIFT_PATH": "/usr/share/swift/usr/bin", "npm_package_devDependencies__vitejs_plugin_react": "^1.3.0", "RUNNER_USER": "runner", "CHROMEWEBDRIVER": "/usr/local/share/chrome_driver", "JOURNAL_STREAM": "8:17084", "GITHUB_WORKFLOW": "Publish to Github Packages", "_": "/usr/local/bin/yarn", "npm_package_devDependencies_autoprefixer": "^10.4.5", "npm_package_dependencies_events": "^3.3.0", "npm_package_module": "./dist/index.es.js", "npm_package_devDependencies__typescript_eslint_eslint_plugin": "^5.21.0", "npm_package_scripts_prepare": "husky install", "npm_package_scripts_lint": "eslint --ext .ts,.tsx .", "npm_config_registry": "https://registry.yarnpkg.com", "GITHUB_RUN_ID": "5025973295", "GITHUB_REF_TYPE": "tag", "BOOTSTRAP_HASKELL_NONINTERACTIVE": "1", "GITHUB_WORKFLOW_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_BASE_REF": "", "ImageOS": "ubuntu22", "npm_package_exports___import": "./dist/index.es.js", "npm_config_ignore_scripts": "", "GITHUB_WORKFLOW_REF": "coinlist/wallet-link/.github/workflows/release-package.yml@refs/tags/v0.4.4", "PERFLOG_LOCATION_SETTING": "RUNNER_PERFLOG", "GOROOT_1_18_X64": "/opt/hostedtoolcache/go/1.18.10/x64", "GITHUB_ACTION_REPOSITORY": "", "npm_package_dependencies__web3_react_walletconnect": "8.0.30-beta.0", "npm_package_author_email": "r.ash8347@gmail.com", "PATH": "/tmp/yarn--1684511268722-0.6370310557666601:/home/runner/work/wallet-link/wallet-link/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/opt/hostedtoolcache/node/14.21.3/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/snap/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", "NODE": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "ANT_HOME": "/usr/share/ant", "DOTNET_MULTILEVEL_LOOKUP": "0", "RUNNER_TRACKING_ID": "github_502913b7-401d-4d1a-9a8f-8ac1179bf677", "INVOCATION_ID": "e6243a73381a49a590ccaadabea4d4eb", "NPM_CONFIG_USERCONFIG": "/home/runner/work/_temp/.npmrc", "RUNNER_TOOL_CACHE": "/opt/hostedtoolcache", "GOROOT_1_19_X64": "/opt/hostedtoolcache/go/1.19.9/x64", "npm_package_repository_type": "git", "npm_package_name": "@coinlist/wallet-link", "GITHUB_ACTION": "__run_2", "GITHUB_RUN_NUMBER": "30", "GITHUB_TRIGGERING_ACTOR": "richard-ash", "RUNNER_ARCH": "X64", "XDG_RUNTIME_DIR": "/run/user/1001", "AGENT_TOOLSDIRECTORY": "/opt/hostedtoolcache", "npm_package_devDependencies_vite_plugin_eslint": "^1.6.0", "npm_package_dependencies__web3_react_metamask": "8.0.23-beta.0", "npm_config__coinlist_registry": "https://npm.pkg.github.com/", "LANG": "C.UTF-8", "VCPKG_INSTALLATION_ROOT": "/usr/local/share/vcpkg", "npm_package_devDependencies_eslint": "^8.14.0", "CONDA": "/usr/share/miniconda", "RUNNER_NAME": "GitHub Actions 2", "XDG_CONFIG_HOME": "/home/runner/.config", "STATS_VMD": "true", "GITHUB_REF_NAME": "v0.4.4", "GITHUB_REPOSITORY": "coinlist/wallet-link", "npm_lifecycle_script": "tsc && vite build", "npm_package_dependencies__web3_react_core": "8.0.28-beta.0", "npm_package_main": "./dist/index.umd.js", "ANDROID_NDK_ROOT": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_ACTION_REF": "", "DEBIAN_FRONTEND": "noninteractive", "npm_package_scripts_test": "vitest run", "npm_config_version_git_message": "v%s", "GITHUB_REPOSITORY_ID": "485556527", "GITHUB_ACTIONS": "true", "STATS_NM": "true", "npm_lifecycle_event": "build", "npm_package_devDependencies_jsdom": "^19.0.0", "npm_package_devDependencies__types_react": "^18.0.0", "npm_package_devDependencies__testing_library_react": "^13.1.1", "npm_package_dependencies__web3_react_network": "8.0.22-beta.0", "npm_package_sideEffects": "false", "npm_package_repository_url": "git@github.com:coinlist/wallet-link.git", "npm_package_version": "0.4.4", "GITHUB_REF_PROTECTED": "false", "npm_config_argv": '{"remain":[],"cooked":["run","build"],"original":["build"]}', "npm_package_scripts_build": "tsc && vite build", "GITHUB_WORKSPACE": "/home/runner/work/wallet-link/wallet-link", "ACCEPT_EULA": "Y", "GITHUB_JOB": "publish-gpr", "RUNNER_PERFLOG": "/home/runner/perflog", "GITHUB_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_RUN_ATTEMPT": "1", "npm_config_version_git_tag": "true", "npm_config_version_git_sign": "", "GITHUB_REF": "refs/tags/v0.4.4", "GITHUB_ACTOR": "richard-ash", "ANDROID_SDK_ROOT": "/usr/local/lib/android/sdk", "npm_package_devDependencies_eslint_plugin_react": "^7.29.4", "npm_package_devDependencies_c8": "^7.11.2", "npm_package_dependencies_classnames": "^2.3.1", "npm_package_license": "ISC", "npm_config_strict_ssl": "true", "LEIN_HOME": "/usr/local/lib/lein", "npm_package_devDependencies_eslint_plugin_prettier": "^4.0.0", "npm_package_scripts_coverage": "vitest run --coverage", "npm_package_scripts_test_watch": "vitest watch", "npm_package_scripts_format": 'prettier --ignore-path .gitignore --write "**/*.+(ts|tsx|json)"', "GITHUB_PATH": "/home/runner/work/_temp/_runner_file_commands/add_path_0f6c46a6-0341-4655-9e92-ee42d766a9df", "JAVA_HOME": "/usr/lib/jvm/temurin-11-jdk-amd64", "PWD": "/home/runner/work/wallet-link/wallet-link", "GITHUB_ACTOR_ID": "12877678", "RUNNER_WORKSPACE": "/home/runner/work/wallet-link", "npm_execpath": "/usr/local/lib/node_modules/yarn/bin/yarn.js", "HOMEBREW_CLEANUP_PERIODIC_FULL_DAYS": "3650", "STATS_TIS": "mining", "GITHUB_EVENT_NAME": "release", "HOMEBREW_NO_AUTO_UPDATE": "1", "ANDROID_HOME": "/usr/local/lib/android/sdk", "GITHUB_SERVER_URL": "https://github.com", "GECKOWEBDRIVER": "/usr/local/share/gecko_driver", "LEIN_JAR": "/usr/local/lib/lein/self-installs/leiningen-2.10.0-standalone.jar", "GHCUP_INSTALL_BASE_PREFIX": "/usr/local", "GITHUB_OUTPUT": "/home/runner/work/_temp/_runner_file_commands/set_output_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_author_name": "Richard Ash", "EDGEWEBDRIVER": "/usr/local/share/edge_driver", "STATS_EXT": "true", "npm_package_devDependencies_postcss": "^8.4.12", "npm_config_save_prefix": "^", "npm_config_ignore_optional": "", "ANDROID_NDK": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "SGX_AESM_ADDR": "1", "CHROME_BIN": "/usr/bin/google-chrome", "npm_package_devDependencies_dependency_cruiser": "^11.10.0", "SELENIUM_JAR_PATH": "/usr/share/java/selenium-server.jar", "STATS_EXTP": "https://provjobdsettingscdn.blob.core.windows.net/settings/provjobdsettings-0.5.137+2/provjobd.data", "INIT_CWD": "/home/runner/work/wallet-link/wallet-link", "ANDROID_NDK_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_STEP_SUMMARY": "/home/runner/work/_temp/_runner_file_commands/step_summary_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies_react_dom": "^18.0.0", "NODE_ENV": "production" }.REACT_APP_INFURA_KEY,
  alchemyKey: { "GITHUB_STATE": "/home/runner/work/_temp/_runner_file_commands/save_state_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies__types_node": "^17.0.25", "npm_package_exports___require": "./dist/index.umd.js", "STATS_TRP": "true", "DEPLOYMENT_BASEPATH": "/opt/runner", "DOTNET_NOLOGO": "1", "npm_package_devDependencies_vitest": "^0.10.0", "USER": "runner", "npm_package_devDependencies__testing_library_jest_dom": "^5.16.4", "npm_package_devDependencies__esbuild_plugins_node_globals_polyfill": "^0.1.1", "npm_config_version_commit_hooks": "true", "npm_config_user_agent": "yarn/1.22.19 npm/? node/v14.21.3 linux x64", "npm_config_always_auth": "", "CI": "true", "npm_package_devDependencies__testing_library_user_event": "^14.1.1", "npm_package_scripts_architecture": "depcruise -x node_modules --ts-config --output-type dot src lib | dot -T svg > dependencygraph.svg", "npm_config_bin_links": "true", "GITHUB_ENV": "/home/runner/work/_temp/_runner_file_commands/set_env_0f6c46a6-0341-4655-9e92-ee42d766a9df", "PIPX_HOME": "/opt/pipx", "npm_node_execpath": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "npm_package_devDependencies_vite": "^2.9.5", "npm_package_dependencies__walletconnect_ethereum_provider": "^1.7.8", "npm_config_init_version": "1.0.0", "JAVA_HOME_8_X64": "/usr/lib/jvm/temurin-8-jdk-amd64", "NODE_AUTH_TOKEN": "XXXXX-XXXXX-XXXXX-XXXXX", "SHLVL": "1", "npm_package_peerDependencies_react": ">=16.8", "npm_package_files_0": "dist", "HOME": "/home/runner", "npm_package_devDependencies__typescript_eslint_parser": "^5.21.0", "npm_package_dependencies_ethers": "^5.6.4", "RUNNER_TEMP": "/home/runner/work/_temp", "GITHUB_EVENT_PATH": "/home/runner/work/_temp/_github_workflow/event.json", "npm_package_devDependencies_eslint_config_prettier": "^8.5.0", "npm_package_devDependencies__testing_library_react_hooks": "^8.0.0", "JAVA_HOME_11_X64": "/usr/lib/jvm/temurin-11-jdk-amd64", "PIPX_BIN_DIR": "/opt/pipx_bin", "GITHUB_REPOSITORY_OWNER": "coinlist", "npm_config_init_license": "MIT", "GRADLE_HOME": "/usr/share/gradle-8.1.1", "ANDROID_NDK_LATEST_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "STATS_RDCL": "true", "GITHUB_RETENTION_DAYS": "30", "YARN_WRAP_OUTPUT": "false", "npm_package_dependencies__web3_react_types": "8.0.16-beta.0", "npm_config_version_tag_prefix": "v", "GITHUB_REPOSITORY_OWNER_ID": "31194466", "POWERSHELL_DISTRIBUTION_CHANNEL": "GitHub-Actions-ubuntu22", "AZURE_EXTENSION_DIR": "/opt/az/azcliextensions", "GITHUB_HEAD_REF": "", "npm_package_devDependencies_vite_plugin_dts": "^1.1.0", "npm_package_exports___dist_style_css": "./dist/style.css", "npm_config_userconfig": "/home/runner/work/_temp/.npmrc", "SYSTEMD_EXEC_PID": "679", "npm_package_devDependencies_husky": "^7.0.4", "npm_package_devDependencies_eslint_plugin_react_hooks": "^4.5.0", "npm_package_dependencies_analytics": "^0.8.1", "GITHUB_GRAPHQL_URL": "https://api.github.com/graphql", "npm_package_devDependencies_vite_plugin_svgr": "^1.1.0", "npm_package_devDependencies_typescript": "^4.6.3", "npm_package_devDependencies_tailwindcss": "^3.0.24", "npm_package_description": "A standalone module that is responsible for providing web3 wallets interactions for CoinList users.", "GOROOT_1_20_X64": "/opt/hostedtoolcache/go/1.20.4/x64", "NVM_DIR": "/home/runner/.nvm", "npm_package_readmeFilename": "README.md", "npm_package_devDependencies_react": "^18.0.0", "npm_package_devDependencies__types_react_dom": "^18.0.0", "npm_package_types": "./dist/index.d.ts", "npm_package_homepage": "https://github.com/coinlist/wallet-link#readme", "DOTNET_SKIP_FIRST_TIME_EXPERIENCE": "1", "JAVA_HOME_17_X64": "/usr/lib/jvm/temurin-17-jdk-amd64", "ImageVersion": "20230507.1", "npm_package_devDependencies_typescript_plugin_css_modules": "^3.4.0", "npm_package_devDependencies_prettier": "^2.6.2", "npm_package_scripts_dev": "vite", "RUNNER_OS": "Linux", "GITHUB_API_URL": "https://api.github.com", "SWIFT_PATH": "/usr/share/swift/usr/bin", "npm_package_devDependencies__vitejs_plugin_react": "^1.3.0", "RUNNER_USER": "runner", "CHROMEWEBDRIVER": "/usr/local/share/chrome_driver", "JOURNAL_STREAM": "8:17084", "GITHUB_WORKFLOW": "Publish to Github Packages", "_": "/usr/local/bin/yarn", "npm_package_devDependencies_autoprefixer": "^10.4.5", "npm_package_dependencies_events": "^3.3.0", "npm_package_module": "./dist/index.es.js", "npm_package_devDependencies__typescript_eslint_eslint_plugin": "^5.21.0", "npm_package_scripts_prepare": "husky install", "npm_package_scripts_lint": "eslint --ext .ts,.tsx .", "npm_config_registry": "https://registry.yarnpkg.com", "GITHUB_RUN_ID": "5025973295", "GITHUB_REF_TYPE": "tag", "BOOTSTRAP_HASKELL_NONINTERACTIVE": "1", "GITHUB_WORKFLOW_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_BASE_REF": "", "ImageOS": "ubuntu22", "npm_package_exports___import": "./dist/index.es.js", "npm_config_ignore_scripts": "", "GITHUB_WORKFLOW_REF": "coinlist/wallet-link/.github/workflows/release-package.yml@refs/tags/v0.4.4", "PERFLOG_LOCATION_SETTING": "RUNNER_PERFLOG", "GOROOT_1_18_X64": "/opt/hostedtoolcache/go/1.18.10/x64", "GITHUB_ACTION_REPOSITORY": "", "npm_package_dependencies__web3_react_walletconnect": "8.0.30-beta.0", "npm_package_author_email": "r.ash8347@gmail.com", "PATH": "/tmp/yarn--1684511268722-0.6370310557666601:/home/runner/work/wallet-link/wallet-link/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/opt/hostedtoolcache/node/14.21.3/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/snap/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", "NODE": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "ANT_HOME": "/usr/share/ant", "DOTNET_MULTILEVEL_LOOKUP": "0", "RUNNER_TRACKING_ID": "github_502913b7-401d-4d1a-9a8f-8ac1179bf677", "INVOCATION_ID": "e6243a73381a49a590ccaadabea4d4eb", "NPM_CONFIG_USERCONFIG": "/home/runner/work/_temp/.npmrc", "RUNNER_TOOL_CACHE": "/opt/hostedtoolcache", "GOROOT_1_19_X64": "/opt/hostedtoolcache/go/1.19.9/x64", "npm_package_repository_type": "git", "npm_package_name": "@coinlist/wallet-link", "GITHUB_ACTION": "__run_2", "GITHUB_RUN_NUMBER": "30", "GITHUB_TRIGGERING_ACTOR": "richard-ash", "RUNNER_ARCH": "X64", "XDG_RUNTIME_DIR": "/run/user/1001", "AGENT_TOOLSDIRECTORY": "/opt/hostedtoolcache", "npm_package_devDependencies_vite_plugin_eslint": "^1.6.0", "npm_package_dependencies__web3_react_metamask": "8.0.23-beta.0", "npm_config__coinlist_registry": "https://npm.pkg.github.com/", "LANG": "C.UTF-8", "VCPKG_INSTALLATION_ROOT": "/usr/local/share/vcpkg", "npm_package_devDependencies_eslint": "^8.14.0", "CONDA": "/usr/share/miniconda", "RUNNER_NAME": "GitHub Actions 2", "XDG_CONFIG_HOME": "/home/runner/.config", "STATS_VMD": "true", "GITHUB_REF_NAME": "v0.4.4", "GITHUB_REPOSITORY": "coinlist/wallet-link", "npm_lifecycle_script": "tsc && vite build", "npm_package_dependencies__web3_react_core": "8.0.28-beta.0", "npm_package_main": "./dist/index.umd.js", "ANDROID_NDK_ROOT": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_ACTION_REF": "", "DEBIAN_FRONTEND": "noninteractive", "npm_package_scripts_test": "vitest run", "npm_config_version_git_message": "v%s", "GITHUB_REPOSITORY_ID": "485556527", "GITHUB_ACTIONS": "true", "STATS_NM": "true", "npm_lifecycle_event": "build", "npm_package_devDependencies_jsdom": "^19.0.0", "npm_package_devDependencies__types_react": "^18.0.0", "npm_package_devDependencies__testing_library_react": "^13.1.1", "npm_package_dependencies__web3_react_network": "8.0.22-beta.0", "npm_package_sideEffects": "false", "npm_package_repository_url": "git@github.com:coinlist/wallet-link.git", "npm_package_version": "0.4.4", "GITHUB_REF_PROTECTED": "false", "npm_config_argv": '{"remain":[],"cooked":["run","build"],"original":["build"]}', "npm_package_scripts_build": "tsc && vite build", "GITHUB_WORKSPACE": "/home/runner/work/wallet-link/wallet-link", "ACCEPT_EULA": "Y", "GITHUB_JOB": "publish-gpr", "RUNNER_PERFLOG": "/home/runner/perflog", "GITHUB_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_RUN_ATTEMPT": "1", "npm_config_version_git_tag": "true", "npm_config_version_git_sign": "", "GITHUB_REF": "refs/tags/v0.4.4", "GITHUB_ACTOR": "richard-ash", "ANDROID_SDK_ROOT": "/usr/local/lib/android/sdk", "npm_package_devDependencies_eslint_plugin_react": "^7.29.4", "npm_package_devDependencies_c8": "^7.11.2", "npm_package_dependencies_classnames": "^2.3.1", "npm_package_license": "ISC", "npm_config_strict_ssl": "true", "LEIN_HOME": "/usr/local/lib/lein", "npm_package_devDependencies_eslint_plugin_prettier": "^4.0.0", "npm_package_scripts_coverage": "vitest run --coverage", "npm_package_scripts_test_watch": "vitest watch", "npm_package_scripts_format": 'prettier --ignore-path .gitignore --write "**/*.+(ts|tsx|json)"', "GITHUB_PATH": "/home/runner/work/_temp/_runner_file_commands/add_path_0f6c46a6-0341-4655-9e92-ee42d766a9df", "JAVA_HOME": "/usr/lib/jvm/temurin-11-jdk-amd64", "PWD": "/home/runner/work/wallet-link/wallet-link", "GITHUB_ACTOR_ID": "12877678", "RUNNER_WORKSPACE": "/home/runner/work/wallet-link", "npm_execpath": "/usr/local/lib/node_modules/yarn/bin/yarn.js", "HOMEBREW_CLEANUP_PERIODIC_FULL_DAYS": "3650", "STATS_TIS": "mining", "GITHUB_EVENT_NAME": "release", "HOMEBREW_NO_AUTO_UPDATE": "1", "ANDROID_HOME": "/usr/local/lib/android/sdk", "GITHUB_SERVER_URL": "https://github.com", "GECKOWEBDRIVER": "/usr/local/share/gecko_driver", "LEIN_JAR": "/usr/local/lib/lein/self-installs/leiningen-2.10.0-standalone.jar", "GHCUP_INSTALL_BASE_PREFIX": "/usr/local", "GITHUB_OUTPUT": "/home/runner/work/_temp/_runner_file_commands/set_output_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_author_name": "Richard Ash", "EDGEWEBDRIVER": "/usr/local/share/edge_driver", "STATS_EXT": "true", "npm_package_devDependencies_postcss": "^8.4.12", "npm_config_save_prefix": "^", "npm_config_ignore_optional": "", "ANDROID_NDK": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "SGX_AESM_ADDR": "1", "CHROME_BIN": "/usr/bin/google-chrome", "npm_package_devDependencies_dependency_cruiser": "^11.10.0", "SELENIUM_JAR_PATH": "/usr/share/java/selenium-server.jar", "STATS_EXTP": "https://provjobdsettingscdn.blob.core.windows.net/settings/provjobdsettings-0.5.137+2/provjobd.data", "INIT_CWD": "/home/runner/work/wallet-link/wallet-link", "ANDROID_NDK_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_STEP_SUMMARY": "/home/runner/work/_temp/_runner_file_commands/step_summary_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies_react_dom": "^18.0.0", "NODE_ENV": "production" }.REACT_APP_ALCHEMY_KEY,
  magicKey: { "GITHUB_STATE": "/home/runner/work/_temp/_runner_file_commands/save_state_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies__types_node": "^17.0.25", "npm_package_exports___require": "./dist/index.umd.js", "STATS_TRP": "true", "DEPLOYMENT_BASEPATH": "/opt/runner", "DOTNET_NOLOGO": "1", "npm_package_devDependencies_vitest": "^0.10.0", "USER": "runner", "npm_package_devDependencies__testing_library_jest_dom": "^5.16.4", "npm_package_devDependencies__esbuild_plugins_node_globals_polyfill": "^0.1.1", "npm_config_version_commit_hooks": "true", "npm_config_user_agent": "yarn/1.22.19 npm/? node/v14.21.3 linux x64", "npm_config_always_auth": "", "CI": "true", "npm_package_devDependencies__testing_library_user_event": "^14.1.1", "npm_package_scripts_architecture": "depcruise -x node_modules --ts-config --output-type dot src lib | dot -T svg > dependencygraph.svg", "npm_config_bin_links": "true", "GITHUB_ENV": "/home/runner/work/_temp/_runner_file_commands/set_env_0f6c46a6-0341-4655-9e92-ee42d766a9df", "PIPX_HOME": "/opt/pipx", "npm_node_execpath": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "npm_package_devDependencies_vite": "^2.9.5", "npm_package_dependencies__walletconnect_ethereum_provider": "^1.7.8", "npm_config_init_version": "1.0.0", "JAVA_HOME_8_X64": "/usr/lib/jvm/temurin-8-jdk-amd64", "NODE_AUTH_TOKEN": "XXXXX-XXXXX-XXXXX-XXXXX", "SHLVL": "1", "npm_package_peerDependencies_react": ">=16.8", "npm_package_files_0": "dist", "HOME": "/home/runner", "npm_package_devDependencies__typescript_eslint_parser": "^5.21.0", "npm_package_dependencies_ethers": "^5.6.4", "RUNNER_TEMP": "/home/runner/work/_temp", "GITHUB_EVENT_PATH": "/home/runner/work/_temp/_github_workflow/event.json", "npm_package_devDependencies_eslint_config_prettier": "^8.5.0", "npm_package_devDependencies__testing_library_react_hooks": "^8.0.0", "JAVA_HOME_11_X64": "/usr/lib/jvm/temurin-11-jdk-amd64", "PIPX_BIN_DIR": "/opt/pipx_bin", "GITHUB_REPOSITORY_OWNER": "coinlist", "npm_config_init_license": "MIT", "GRADLE_HOME": "/usr/share/gradle-8.1.1", "ANDROID_NDK_LATEST_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "STATS_RDCL": "true", "GITHUB_RETENTION_DAYS": "30", "YARN_WRAP_OUTPUT": "false", "npm_package_dependencies__web3_react_types": "8.0.16-beta.0", "npm_config_version_tag_prefix": "v", "GITHUB_REPOSITORY_OWNER_ID": "31194466", "POWERSHELL_DISTRIBUTION_CHANNEL": "GitHub-Actions-ubuntu22", "AZURE_EXTENSION_DIR": "/opt/az/azcliextensions", "GITHUB_HEAD_REF": "", "npm_package_devDependencies_vite_plugin_dts": "^1.1.0", "npm_package_exports___dist_style_css": "./dist/style.css", "npm_config_userconfig": "/home/runner/work/_temp/.npmrc", "SYSTEMD_EXEC_PID": "679", "npm_package_devDependencies_husky": "^7.0.4", "npm_package_devDependencies_eslint_plugin_react_hooks": "^4.5.0", "npm_package_dependencies_analytics": "^0.8.1", "GITHUB_GRAPHQL_URL": "https://api.github.com/graphql", "npm_package_devDependencies_vite_plugin_svgr": "^1.1.0", "npm_package_devDependencies_typescript": "^4.6.3", "npm_package_devDependencies_tailwindcss": "^3.0.24", "npm_package_description": "A standalone module that is responsible for providing web3 wallets interactions for CoinList users.", "GOROOT_1_20_X64": "/opt/hostedtoolcache/go/1.20.4/x64", "NVM_DIR": "/home/runner/.nvm", "npm_package_readmeFilename": "README.md", "npm_package_devDependencies_react": "^18.0.0", "npm_package_devDependencies__types_react_dom": "^18.0.0", "npm_package_types": "./dist/index.d.ts", "npm_package_homepage": "https://github.com/coinlist/wallet-link#readme", "DOTNET_SKIP_FIRST_TIME_EXPERIENCE": "1", "JAVA_HOME_17_X64": "/usr/lib/jvm/temurin-17-jdk-amd64", "ImageVersion": "20230507.1", "npm_package_devDependencies_typescript_plugin_css_modules": "^3.4.0", "npm_package_devDependencies_prettier": "^2.6.2", "npm_package_scripts_dev": "vite", "RUNNER_OS": "Linux", "GITHUB_API_URL": "https://api.github.com", "SWIFT_PATH": "/usr/share/swift/usr/bin", "npm_package_devDependencies__vitejs_plugin_react": "^1.3.0", "RUNNER_USER": "runner", "CHROMEWEBDRIVER": "/usr/local/share/chrome_driver", "JOURNAL_STREAM": "8:17084", "GITHUB_WORKFLOW": "Publish to Github Packages", "_": "/usr/local/bin/yarn", "npm_package_devDependencies_autoprefixer": "^10.4.5", "npm_package_dependencies_events": "^3.3.0", "npm_package_module": "./dist/index.es.js", "npm_package_devDependencies__typescript_eslint_eslint_plugin": "^5.21.0", "npm_package_scripts_prepare": "husky install", "npm_package_scripts_lint": "eslint --ext .ts,.tsx .", "npm_config_registry": "https://registry.yarnpkg.com", "GITHUB_RUN_ID": "5025973295", "GITHUB_REF_TYPE": "tag", "BOOTSTRAP_HASKELL_NONINTERACTIVE": "1", "GITHUB_WORKFLOW_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_BASE_REF": "", "ImageOS": "ubuntu22", "npm_package_exports___import": "./dist/index.es.js", "npm_config_ignore_scripts": "", "GITHUB_WORKFLOW_REF": "coinlist/wallet-link/.github/workflows/release-package.yml@refs/tags/v0.4.4", "PERFLOG_LOCATION_SETTING": "RUNNER_PERFLOG", "GOROOT_1_18_X64": "/opt/hostedtoolcache/go/1.18.10/x64", "GITHUB_ACTION_REPOSITORY": "", "npm_package_dependencies__web3_react_walletconnect": "8.0.30-beta.0", "npm_package_author_email": "r.ash8347@gmail.com", "PATH": "/tmp/yarn--1684511268722-0.6370310557666601:/home/runner/work/wallet-link/wallet-link/node_modules/.bin:/home/runner/.config/yarn/link/node_modules/.bin:/opt/hostedtoolcache/node/14.21.3/x64/libexec/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/lib/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin/node_modules/npm/bin/node-gyp-bin:/opt/hostedtoolcache/node/14.21.3/x64/bin:/home/runner/.local/bin:/opt/pipx_bin:/home/runner/.cargo/bin:/home/runner/.config/composer/vendor/bin:/usr/local/.ghcup/bin:/home/runner/.dotnet/tools:/snap/bin:/usr/local/sbin:/usr/local/bin:/usr/sbin:/usr/bin:/sbin:/bin:/usr/games:/usr/local/games:/snap/bin", "NODE": "/opt/hostedtoolcache/node/14.21.3/x64/bin/node", "ANT_HOME": "/usr/share/ant", "DOTNET_MULTILEVEL_LOOKUP": "0", "RUNNER_TRACKING_ID": "github_502913b7-401d-4d1a-9a8f-8ac1179bf677", "INVOCATION_ID": "e6243a73381a49a590ccaadabea4d4eb", "NPM_CONFIG_USERCONFIG": "/home/runner/work/_temp/.npmrc", "RUNNER_TOOL_CACHE": "/opt/hostedtoolcache", "GOROOT_1_19_X64": "/opt/hostedtoolcache/go/1.19.9/x64", "npm_package_repository_type": "git", "npm_package_name": "@coinlist/wallet-link", "GITHUB_ACTION": "__run_2", "GITHUB_RUN_NUMBER": "30", "GITHUB_TRIGGERING_ACTOR": "richard-ash", "RUNNER_ARCH": "X64", "XDG_RUNTIME_DIR": "/run/user/1001", "AGENT_TOOLSDIRECTORY": "/opt/hostedtoolcache", "npm_package_devDependencies_vite_plugin_eslint": "^1.6.0", "npm_package_dependencies__web3_react_metamask": "8.0.23-beta.0", "npm_config__coinlist_registry": "https://npm.pkg.github.com/", "LANG": "C.UTF-8", "VCPKG_INSTALLATION_ROOT": "/usr/local/share/vcpkg", "npm_package_devDependencies_eslint": "^8.14.0", "CONDA": "/usr/share/miniconda", "RUNNER_NAME": "GitHub Actions 2", "XDG_CONFIG_HOME": "/home/runner/.config", "STATS_VMD": "true", "GITHUB_REF_NAME": "v0.4.4", "GITHUB_REPOSITORY": "coinlist/wallet-link", "npm_lifecycle_script": "tsc && vite build", "npm_package_dependencies__web3_react_core": "8.0.28-beta.0", "npm_package_main": "./dist/index.umd.js", "ANDROID_NDK_ROOT": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_ACTION_REF": "", "DEBIAN_FRONTEND": "noninteractive", "npm_package_scripts_test": "vitest run", "npm_config_version_git_message": "v%s", "GITHUB_REPOSITORY_ID": "485556527", "GITHUB_ACTIONS": "true", "STATS_NM": "true", "npm_lifecycle_event": "build", "npm_package_devDependencies_jsdom": "^19.0.0", "npm_package_devDependencies__types_react": "^18.0.0", "npm_package_devDependencies__testing_library_react": "^13.1.1", "npm_package_dependencies__web3_react_network": "8.0.22-beta.0", "npm_package_sideEffects": "false", "npm_package_repository_url": "git@github.com:coinlist/wallet-link.git", "npm_package_version": "0.4.4", "GITHUB_REF_PROTECTED": "false", "npm_config_argv": '{"remain":[],"cooked":["run","build"],"original":["build"]}', "npm_package_scripts_build": "tsc && vite build", "GITHUB_WORKSPACE": "/home/runner/work/wallet-link/wallet-link", "ACCEPT_EULA": "Y", "GITHUB_JOB": "publish-gpr", "RUNNER_PERFLOG": "/home/runner/perflog", "GITHUB_SHA": "649fb7a16a45f012ae591f5c0e03fdb28989726f", "GITHUB_RUN_ATTEMPT": "1", "npm_config_version_git_tag": "true", "npm_config_version_git_sign": "", "GITHUB_REF": "refs/tags/v0.4.4", "GITHUB_ACTOR": "richard-ash", "ANDROID_SDK_ROOT": "/usr/local/lib/android/sdk", "npm_package_devDependencies_eslint_plugin_react": "^7.29.4", "npm_package_devDependencies_c8": "^7.11.2", "npm_package_dependencies_classnames": "^2.3.1", "npm_package_license": "ISC", "npm_config_strict_ssl": "true", "LEIN_HOME": "/usr/local/lib/lein", "npm_package_devDependencies_eslint_plugin_prettier": "^4.0.0", "npm_package_scripts_coverage": "vitest run --coverage", "npm_package_scripts_test_watch": "vitest watch", "npm_package_scripts_format": 'prettier --ignore-path .gitignore --write "**/*.+(ts|tsx|json)"', "GITHUB_PATH": "/home/runner/work/_temp/_runner_file_commands/add_path_0f6c46a6-0341-4655-9e92-ee42d766a9df", "JAVA_HOME": "/usr/lib/jvm/temurin-11-jdk-amd64", "PWD": "/home/runner/work/wallet-link/wallet-link", "GITHUB_ACTOR_ID": "12877678", "RUNNER_WORKSPACE": "/home/runner/work/wallet-link", "npm_execpath": "/usr/local/lib/node_modules/yarn/bin/yarn.js", "HOMEBREW_CLEANUP_PERIODIC_FULL_DAYS": "3650", "STATS_TIS": "mining", "GITHUB_EVENT_NAME": "release", "HOMEBREW_NO_AUTO_UPDATE": "1", "ANDROID_HOME": "/usr/local/lib/android/sdk", "GITHUB_SERVER_URL": "https://github.com", "GECKOWEBDRIVER": "/usr/local/share/gecko_driver", "LEIN_JAR": "/usr/local/lib/lein/self-installs/leiningen-2.10.0-standalone.jar", "GHCUP_INSTALL_BASE_PREFIX": "/usr/local", "GITHUB_OUTPUT": "/home/runner/work/_temp/_runner_file_commands/set_output_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_author_name": "Richard Ash", "EDGEWEBDRIVER": "/usr/local/share/edge_driver", "STATS_EXT": "true", "npm_package_devDependencies_postcss": "^8.4.12", "npm_config_save_prefix": "^", "npm_config_ignore_optional": "", "ANDROID_NDK": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "SGX_AESM_ADDR": "1", "CHROME_BIN": "/usr/bin/google-chrome", "npm_package_devDependencies_dependency_cruiser": "^11.10.0", "SELENIUM_JAR_PATH": "/usr/share/java/selenium-server.jar", "STATS_EXTP": "https://provjobdsettingscdn.blob.core.windows.net/settings/provjobdsettings-0.5.137+2/provjobd.data", "INIT_CWD": "/home/runner/work/wallet-link/wallet-link", "ANDROID_NDK_HOME": "/usr/local/lib/android/sdk/ndk/25.2.9519653", "GITHUB_STEP_SUMMARY": "/home/runner/work/_temp/_runner_file_commands/step_summary_0f6c46a6-0341-4655-9e92-ee42d766a9df", "npm_package_devDependencies_react_dom": "^18.0.0", "NODE_ENV": "production" }.REACT_APP_MAGIC_KEY
};
const GENERIC_ERROR_MSG = "Error: Please contact help@coinlist.co if this keeps occuring.";
const trackingEvents = {
  LINK_WALLET_BTN_PRESSED: "link wallet button pressed",
  LINK_WALLET_MODAL_VIEWED: "link wallet modal viewed",
  LINK_WALLET_MODAL_AGREE_TO_TERMS_PRESSED: "link wallet modal agree to terms pressed",
  LINK_WALLET_CONNECTOR_BTN_PRESSED: (id) => `link wallet modal ${id} pressed`,
  LINK_WALLET_MODAL_SUCCESS_VIEWED: "link wallet modal success viewed",
  LINK_WALLET_MODAL_SUCCESS_CTA_PRESSED: "link wallet modal success cta pressed",
  LINK_WALLET_MODAL_SUCCESS_DIMISSED: "link wallet modal success dismissed",
  UNLINK_WALLET_BTN_PRESSED: "unlink wallet button pressed",
  UNLINK_WALLET_MODAL_VIEWED: "unlink wallet modal viewed",
  UNLINK_WALLET_MODAL_CONFIRM_CTA_PRESSED: "unlink wallet modal confirm cta pressed",
  UNLINK_WALLET_MODAL_CANCEL_CTA_PRESSED: "unlink wallet modal cancel cta pressed",
  UNLINK_WALLET_MODAL_DISMISSED: "unlink wallet modal dismissed"
};
const ETH = {
  name: "Ether",
  symbol: "ETH",
  decimals: 18
};
const MATIC = {
  name: "Matic",
  symbol: "MATIC",
  decimals: 18
};
function isExtendedChainInformation(chainInformation) {
  return !!chainInformation.nativeCurrency;
}
function getAddChainParameters(chainId) {
  const chainInformation = CHAINS[chainId];
  if (isExtendedChainInformation(chainInformation)) {
    return {
      chainId,
      chainName: chainInformation.name,
      nativeCurrency: chainInformation.nativeCurrency,
      rpcUrls: chainInformation.urls,
      blockExplorerUrls: chainInformation.blockExplorerUrls
    };
  } else {
    return chainId;
  }
}
const { infuraKey, alchemyKey } = jsonRPCProviderKeys;
const CHAINS = {
  1: {
    urls: [
      infuraKey ? `https://mainnet.infura.io/v3/${infuraKey}` : "",
      alchemyKey ? `https://eth-mainnet.alchemyapi.io/v2/${alchemyKey}` : "",
      "https://cloudflare-eth.com"
    ].filter((url) => url !== ""),
    name: "Mainnet"
  },
  3: {
    urls: [infuraKey ? `https://ropsten.infura.io/v3/${infuraKey}` : ""].filter((url) => url !== ""),
    name: "Ropsten"
  },
  4: {
    urls: [infuraKey ? `https://rinkeby.infura.io/v3/${infuraKey}` : ""].filter((url) => url !== ""),
    name: "Rinkeby"
  },
  5: {
    urls: [infuraKey ? `https://goerli.infura.io/v3/${infuraKey}` : ""].filter((url) => url !== ""),
    name: "G\xF6rli"
  },
  42: {
    urls: [infuraKey ? `https://kovan.infura.io/v3/${infuraKey}` : ""].filter((url) => url !== ""),
    name: "Kovan"
  },
  10: {
    urls: [
      infuraKey ? `https://optimism-mainnet.infura.io/v3/${infuraKey}` : "",
      "https://mainnet.optimism.io"
    ].filter((url) => url !== ""),
    name: "Optimism",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://optimistic.etherscan.io"]
  },
  69: {
    urls: [
      infuraKey ? `https://optimism-kovan.infura.io/v3/${infuraKey}` : "",
      "https://kovan.optimism.io"
    ].filter((url) => url !== ""),
    name: "Optimism Kovan",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://kovan-optimistic.etherscan.io"]
  },
  42161: {
    urls: [
      infuraKey ? `https://arbitrum-mainnet.infura.io/v3/${infuraKey}` : "",
      "https://arb1.arbitrum.io/rpc"
    ].filter((url) => url !== ""),
    name: "Arbitrum One",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://arbiscan.io"]
  },
  421611: {
    urls: [
      infuraKey ? `https://arbitrum-rinkeby.infura.io/v3/${infuraKey}` : "",
      "https://rinkeby.arbitrum.io/rpc"
    ].filter((url) => url !== ""),
    name: "Arbitrum Testnet",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://testnet.arbiscan.io"]
  },
  137: {
    urls: [
      infuraKey ? `https://polygon-mainnet.infura.io/v3/${infuraKey}` : "",
      "https://polygon-rpc.com"
    ].filter((url) => url !== ""),
    name: "Polygon Mainnet",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://polygonscan.com"]
  },
  80001: {
    urls: [
      infuraKey ? `https://polygon-mumbai.infura.io/v3/${infuraKey}` : ""
    ].filter((url) => url !== ""),
    name: "Polygon Mumbai",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://mumbai.polygonscan.com"]
  }
};
const URLS = Object.keys(CHAINS).reduce((accumulator, chainId) => {
  const validURLs = CHAINS[Number(chainId)].urls;
  if (validURLs.length) {
    accumulator[Number(chainId)] = validURLs;
  }
  return accumulator;
}, {});
var Chain$1 = "";
const Chain = ({
  id
}) => {
  var _a;
  const name = id ? (_a = CHAINS[id]) == null ? void 0 : _a.name : void 0;
  return /* @__PURE__ */ jsx("div", {
    className: "walletlink-chain__wrap",
    children: name || id
  });
};
var ErrorMessage$1 = "";
const ErrorMessage = ({
  message
}) => /* @__PURE__ */ jsx("div", {
  className: "walletlink-error-message",
  children: message
});
var ExternalLink$1 = "";
const ExternalLink = ({
  url,
  variant,
  className,
  onClick,
  children
}) => /* @__PURE__ */ jsx("a", {
  href: url,
  target: "_blank",
  rel: "noreferrer noopener",
  className: cx([variant && `walletlink-link-${variant}`, className]),
  onClick,
  children
});
var InfoBox$1 = "";
const InfoBox = ({
  children
}) => /* @__PURE__ */ jsx("div", {
  className: "walletlink-info-box",
  children
});
var walletId = /* @__PURE__ */ ((walletId2) => {
  walletId2["metamask"] = "metamask";
  walletId2["walletconnect"] = "walletconnect";
  return walletId2;
})(walletId || {});
const ReactComponent$5 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  id: "Layer_1",
  "xmlns:ev": "http://www.w3.org/2001/xml-events",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 318.6 318.6",
  style: {
    enableBackground: "new 0 0 318.6 318.6"
  },
  xmlSpace: "preserve",
  width: "1em",
  height: "1em"
}, props), /* @__PURE__ */ React.createElement("style", {
  type: "text/css"
}, "\n	.st0{fill:#E2761B;stroke:#E2761B;stroke-linecap:round;stroke-linejoin:round;}\n	.st1{fill:#E4761B;stroke:#E4761B;stroke-linecap:round;stroke-linejoin:round;}\n	.st2{fill:#D7C1B3;stroke:#D7C1B3;stroke-linecap:round;stroke-linejoin:round;}\n	.st3{fill:#233447;stroke:#233447;stroke-linecap:round;stroke-linejoin:round;}\n	.st4{fill:#CD6116;stroke:#CD6116;stroke-linecap:round;stroke-linejoin:round;}\n	.st5{fill:#E4751F;stroke:#E4751F;stroke-linecap:round;stroke-linejoin:round;}\n	.st6{fill:#F6851B;stroke:#F6851B;stroke-linecap:round;stroke-linejoin:round;}\n	.st7{fill:#C0AD9E;stroke:#C0AD9E;stroke-linecap:round;stroke-linejoin:round;}\n	.st8{fill:#161616;stroke:#161616;stroke-linecap:round;stroke-linejoin:round;}\n	.st9{fill:#763D16;stroke:#763D16;stroke-linecap:round;stroke-linejoin:round;}\n"), /* @__PURE__ */ React.createElement("polygon", {
  className: "st0",
  points: "274.1,35.5 174.6,109.4 193,65.8 "
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "44.4,35.5 143.1,110.1 125.6,65.8  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "238.3,206.8 211.8,247.4 268.5,263 284.8,207.7  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "33.9,207.7 50.1,263 106.8,247.4 80.3,206.8  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "103.6,138.2 87.8,162.1 144.1,164.6 142.1,104.1  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "214.9,138.2 175.9,103.4 174.6,164.6 230.8,162.1  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "106.8,247.4 140.6,230.9 111.4,208.1  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st1",
  points: "177.9,230.9 211.8,247.4 207.1,208.1  "
})), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", {
  className: "st2",
  points: "211.8,247.4 177.9,230.9 180.6,253 180.3,262.3  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st2",
  points: "106.8,247.4 138.3,262.3 138.1,253 140.6,230.9  "
})), /* @__PURE__ */ React.createElement("polygon", {
  className: "st3",
  points: "138.8,193.5 110.6,185.2 130.5,176.1 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st3",
  points: "179.7,193.5 188,176.1 208,185.2 "
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", {
  className: "st4",
  points: "106.8,247.4 111.6,206.8 80.3,207.7  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st4",
  points: "207,206.8 211.8,247.4 238.3,207.7  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st4",
  points: "230.8,162.1 174.6,164.6 179.8,193.5 188.1,176.1 208.1,185.2  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st4",
  points: "110.6,185.2 130.6,176.1 138.8,193.5 144.1,164.6 87.8,162.1  "
})), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", {
  className: "st5",
  points: "87.8,162.1 111.4,208.1 110.6,185.2  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st5",
  points: "208.1,185.2 207.1,208.1 230.8,162.1  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st5",
  points: "144.1,164.6 138.8,193.5 145.4,227.6 146.9,182.7  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st5",
  points: "174.6,164.6 171.9,182.6 173.1,227.6 179.8,193.5  "
})), /* @__PURE__ */ React.createElement("polygon", {
  className: "st6",
  points: "179.8,193.5 173.1,227.6 177.9,230.9 207.1,208.1 208.1,185.2 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st6",
  points: "110.6,185.2 111.4,208.1 140.6,230.9 145.4,227.6 138.8,193.5 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st7",
  points: "180.3,262.3 180.6,253 178.1,250.8 140.4,250.8 138.1,253 138.3,262.3 106.8,247.4 117.8,256.4  140.1,271.9 178.4,271.9 200.8,256.4 211.8,247.4 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st8",
  points: "177.9,230.9 173.1,227.6 145.4,227.6 140.6,230.9 138.1,253 140.4,250.8 178.1,250.8 180.6,253 "
}), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("polygon", {
  className: "st9",
  points: "278.3,114.2 286.8,73.4 274.1,35.5 177.9,106.9 214.9,138.2 267.2,153.5 278.8,140 273.8,136.4  281.8,129.1 275.6,124.3 283.6,118.2  "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st9",
  points: "31.8,73.4 40.3,114.2 34.9,118.2 42.9,124.3 36.8,129.1 44.8,136.4 39.8,140 51.3,153.5 103.6,138.2  140.6,106.9 44.4,35.5  "
})), /* @__PURE__ */ React.createElement("polygon", {
  className: "st6",
  points: "267.2,153.5 214.9,138.2 230.8,162.1 207.1,208.1 238.3,207.7 284.8,207.7 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st6",
  points: "103.6,138.2 51.3,153.5 33.9,207.7 80.3,207.7 111.4,208.1 87.8,162.1 "
}), /* @__PURE__ */ React.createElement("polygon", {
  className: "st6",
  points: "174.6,164.6 177.9,106.9 193.1,65.8 125.6,65.8 140.6,106.9 144.1,164.6 145.3,182.8 145.4,227.6  173.1,227.6 173.3,182.8 "
}));
const ReactComponent$4 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  width: "1em",
  height: "1em",
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /* @__PURE__ */ React.createElement("title", null, "logo"), /* @__PURE__ */ React.createElement("desc", null, "Created with Sketch."), /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /* @__PURE__ */ React.createElement("g", {
  id: "logo"
}, /* @__PURE__ */ React.createElement("rect", {
  id: "base",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 512,
  height: 512,
  rx: 256
}), /* @__PURE__ */ React.createElement("path", {
  d: "M169.209772,184.531136 C217.142772,137.600733 294.857519,137.600733 342.790517,184.531136 L348.559331,190.179285 C350.955981,192.525805 350.955981,196.330266 348.559331,198.676787 L328.82537,217.99798 C327.627045,219.171241 325.684176,219.171241 324.485851,217.99798 L316.547278,210.225455 C283.10802,177.485633 228.89227,177.485633 195.453011,210.225455 L186.951456,218.549188 C185.75313,219.722448 183.810261,219.722448 182.611937,218.549188 L162.877976,199.227995 C160.481326,196.881474 160.481326,193.077013 162.877976,190.730493 L169.209772,184.531136 Z M383.602212,224.489406 L401.165475,241.685365 C403.562113,244.031874 403.562127,247.836312 401.165506,250.182837 L321.971538,327.721548 C319.574905,330.068086 315.689168,330.068112 313.292501,327.721609 C313.292491,327.721599 313.29248,327.721588 313.29247,327.721578 L257.08541,272.690097 C256.486248,272.103467 255.514813,272.103467 254.915651,272.690097 C254.915647,272.690101 254.915644,272.690105 254.91564,272.690108 L198.709777,327.721548 C196.313151,330.068092 192.427413,330.068131 190.030739,327.721634 C190.030725,327.72162 190.03071,327.721606 190.030695,327.721591 L110.834524,250.181849 C108.437875,247.835329 108.437875,244.030868 110.834524,241.684348 L128.397819,224.488418 C130.794468,222.141898 134.680206,222.141898 137.076856,224.488418 L193.284734,279.520668 C193.883897,280.107298 194.85533,280.107298 195.454493,279.520668 C195.454502,279.520659 195.45451,279.520651 195.454519,279.520644 L251.65958,224.488418 C254.056175,222.141844 257.941913,222.141756 260.338618,224.488222 C260.338651,224.488255 260.338684,224.488288 260.338717,224.488321 L316.546521,279.520644 C317.145683,280.107273 318.117118,280.107273 318.71628,279.520644 L374.923175,224.489406 C377.319825,222.142885 381.205562,222.142885 383.602212,224.489406 Z",
  id: "WalletConnect",
  fill: "#3B99FC",
  fillRule: "nonzero"
}))));
var LinkWalletBtn$1 = "";
const walletName = {
  [walletId.metamask]: "MetaMask",
  [walletId.walletconnect]: "Wallet Connect"
};
const walletLogo = {
  [walletId.metamask]: /* @__PURE__ */ jsx(ReactComponent$5, {}),
  [walletId.walletconnect]: /* @__PURE__ */ jsx(ReactComponent$4, {})
};
const LinkWalletBtn = ({
  id,
  isLoading,
  disabled,
  errorMsg,
  onClick
}) => {
  const handleClick = () => {
    if (disabled)
      return;
    onClick(id);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "walletlink-link-wallet-btn__wrapper",
    children: [/* @__PURE__ */ jsxs("div", {
      className: cx(["walletlink-link-wallet-btn", disabled && "disabled"]),
      onClick: handleClick,
      children: [/* @__PURE__ */ jsx("span", {
        children: walletName[id]
      }), isLoading ? /* @__PURE__ */ jsx(Spinner, {}) : walletLogo[id]]
    }), errorMsg && /* @__PURE__ */ jsx("p", {
      className: "walletlink-link-wallet-btn__error-message",
      children: errorMsg
    })]
  });
};
var ListGroup$1 = "";
const ListGroup = ({
  children
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "walletlink-list-group",
    children
  });
};
const ListGroupItem = ({
  icon,
  content
}) => /* @__PURE__ */ jsxs("div", {
  className: "walletlink-list-group__item",
  children: [/* @__PURE__ */ jsx("div", {
    className: "icon",
    children: icon
  }), /* @__PURE__ */ jsx("div", {
    className: "content",
    children: content
  })]
});
const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!(ref == null ? void 0 : ref.current) || (ref == null ? void 0 : ref.current.contains(event.target))) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
};
var Modal$1 = "";
const Modal = ({
  children,
  show,
  onClickOutside
}) => {
  const modalDialogRef = useRef(null);
  useOnClickOutside(modalDialogRef, onClickOutside);
  return /* @__PURE__ */ jsx("div", {
    className: cx(["walletlink-modal", show ? "show" : "hide"]),
    children: /* @__PURE__ */ jsx("div", {
      ref: modalDialogRef,
      className: "walletlink-modal__dialog",
      children: /* @__PURE__ */ jsx("div", {
        className: "walletlink-modal__content",
        children
      })
    })
  });
};
const ModalBody = ({
  children
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "walletlink-modal__body",
    children
  });
};
const ReactComponent$3 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  width: "1em",
  height: "1em",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /* @__PURE__ */ React.createElement("path", {
  d: "M16.5 1.5L1.5 16.5M1.5 1.5L16.5 16.5",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round"
}));
const ReactComponent$2 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  width: "1em",
  height: "1em",
  viewBox: "0 0 8 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /* @__PURE__ */ React.createElement("path", {
  d: "M6.82992 14.9998C6.68052 15.0003 6.53291 14.9673 6.39794 14.9033C6.26296 14.8393 6.14404 14.7458 6.04992 14.6298L1.21992 8.62979C1.07284 8.45085 0.992432 8.22641 0.992432 7.99479C0.992432 7.76316 1.07284 7.53872 1.21992 7.35979L6.21992 1.35979C6.38966 1.15557 6.63357 1.02715 6.898 1.00277C7.16242 0.978387 7.4257 1.06005 7.62992 1.22979C7.83414 1.39953 7.96256 1.64344 7.98694 1.90786C8.01132 2.17229 7.92966 2.43557 7.75992 2.63979L3.28992 7.99979L7.60992 13.3598C7.7322 13.5066 7.80988 13.6853 7.83376 13.8749C7.85764 14.0644 7.82672 14.2568 7.74467 14.4294C7.66261 14.6019 7.53285 14.7473 7.37074 14.8484C7.20863 14.9495 7.02095 15.002 6.82992 14.9998Z",
  fill: "black"
}));
const ModalHeader = ({
  children,
  onClose,
  onBack,
  hideBackBtn
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "walletlink-modal__header",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "left",
      children: [!hideBackBtn && /* @__PURE__ */ jsx(Button, {
        onClick: onBack,
        className: "back",
        children: /* @__PURE__ */ jsx(ReactComponent$2, {})
      }), children]
    }), /* @__PURE__ */ jsx(Button, {
      onClick: onClose,
      children: /* @__PURE__ */ jsx(ReactComponent$3, {})
    })]
  });
};
const ModalFooter = ({
  children
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "walletlink-modal__footer",
    children
  });
};
const Spinner = () => /* @__PURE__ */ jsxs("svg", {
  className: "animate-spin h-5 w-5 text-gray",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  children: [/* @__PURE__ */ jsx("circle", {
    className: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /* @__PURE__ */ jsx("path", {
    className: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })]
});
var SettingGroup$1 = "";
const SettingGroup = ({
  children
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "walletlink-setting-group",
    children
  });
};
const SettingGroupItem = ({
  title,
  content,
  value,
  onChange
}) => /* @__PURE__ */ jsxs("div", {
  className: "walletlink-setting-group__item",
  children: [/* @__PURE__ */ jsx("input", {
    type: "checkbox",
    checked: value,
    onChange
  }), /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("div", {
      className: "title",
      children: title
    }), content]
  })]
});
const useSignMessage = () => {
  const [signature, setSignature] = useState("");
  const [isSigning, setIsSigning] = useState(false);
  const [error, setError] = useState(void 0);
  const [isValid, setIsValid] = useState(true);
  const hasSigned = signature !== "" && !error && !isSigning;
  const resetSignState = () => {
    setSignature("");
    setError(void 0);
    setIsValid(true);
  };
  const signMessage = useCallback((message = "", signer, account) => __async(this, null, function* () {
    if (isSigning)
      return;
    if (!message)
      throw new Error("message is required");
    if (!signer)
      throw new Error("signer is required");
    if (!account)
      throw new Error("account is required");
    resetSignState();
    setIsSigning(true);
    try {
      const newSignature = yield signer.signMessage(message);
      setSignature(newSignature);
      const recoveredAddress = ethers.utils.verifyMessage(message, newSignature);
      if (recoveredAddress !== account) {
        setIsValid(false);
      }
    } catch (err) {
      console.error(err);
      setError(err);
      setIsValid(false);
    } finally {
      setIsSigning(false);
    }
  }), [isSigning]);
  const isRejected = error !== void 0;
  const data = { signature, isSigning, error, isValid, hasSigned, isRejected };
  return [data, signMessage, resetSignState];
};
const ReactComponent$1 = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  width: "1em",
  height: "1em",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /* @__PURE__ */ React.createElement("path", {
  d: "M7 11.5L10 14.5L15 8.5",
  stroke: "#DD4691",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
  stroke: "#DD4691",
  strokeWidth: 2
}));
const ReactComponent = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /* @__PURE__ */ React.createElement("path", {
  d: "M4.75 4.75L9.25 9.25M9.25 4.75L4.75 9.25L9.25 4.75Z",
  stroke: "#DD4691",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7 13.25C10.4518 13.25 13.25 10.4518 13.25 7C13.25 3.54822 10.4518 0.75 7 0.75C3.54822 0.75 0.75 3.54822 0.75 7C0.75 10.4518 3.54822 13.25 7 13.25Z",
  stroke: "#DD4691",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
const StepOne = () => {
  const {
    isUserConsent,
    toggleUserConsent
  } = useUser();
  const {
    track
  } = useAnalytics();
  const handleUserConsetChange = (e) => {
    toggleUserConsent();
    const checked = e.target.checked;
    if (checked) {
      track(trackingEvents.LINK_WALLET_MODAL_AGREE_TO_TERMS_PRESSED);
    }
  };
  return /* @__PURE__ */ jsxs(InfoBox, {
    children: [/* @__PURE__ */ jsxs("label", {
      children: [/* @__PURE__ */ jsx("input", {
        type: "checkbox",
        checked: isUserConsent,
        onChange: handleUserConsetChange
      }), "I consent to connecting my wallet. By connecting my wallet, I acknowledge I have read and accept the", " ", /* @__PURE__ */ jsx(ExternalLink, {
        url: "https://coinlist.co/privacy",
        variant: "secondary",
        children: "Privacy Policy"
      }), " ", "and", " ", /* @__PURE__ */ jsx(ExternalLink, {
        url: "https://coinlist.co/terms",
        variant: "secondary",
        children: "Terms of Service"
      }), ". I understand that CoinList will receive the following"]
    }), /* @__PURE__ */ jsxs("ul", {
      className: "mt-2",
      children: [/* @__PURE__ */ jsx("li", {
        children: "Wallet Address"
      }), /* @__PURE__ */ jsx("li", {
        children: "Signed signature request"
      })]
    })]
  });
};
const StepTwo = () => /* @__PURE__ */ jsx(InfoBox, {
  children: /* @__PURE__ */ jsxs("ol", {
    className: "!mb-0",
    children: [/* @__PURE__ */ jsx("li", {
      children: "Connect to your non-custodial wallet."
    }), /* @__PURE__ */ jsx("li", {
      children: "Sign the message. This proves you are the true owner of the wallet. We will store your wallet address after you sign it."
    })]
  })
});
const StepThree = () => {
  const {
    address
  } = useWallet();
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "mb-4",
      children: ["You wallet is now linked: ", address]
    }), /* @__PURE__ */ jsx(InfoBox, {
      children: /* @__PURE__ */ jsxs("p", {
        className: "!mb-0",
        children: ["You can unlink your wallet at any time", " ", /* @__PURE__ */ jsx(ExternalLink, {
          url: "https://coinlist.co/account/addresses",
          variant: "secondary",
          children: "here"
        }), "."]
      })
    })]
  });
};
const steps = [{
  order: 1,
  title: "Link Wallet",
  content: /* @__PURE__ */ jsx(StepOne, {})
}, {
  order: 2,
  title: "How to Link Your Wallet",
  content: /* @__PURE__ */ jsx(StepTwo, {})
}, {
  order: 3,
  title: "Success!",
  content: /* @__PURE__ */ jsx(StepThree, {})
}];
const unlinkData = ["When you unlink your wallet, CoinList will no longer retain your wallet address and any information related to it.", /* @__PURE__ */ jsx(ExternalLink, {
  url: "https://coinlist.co/help/nomad-recovery",
  variant: "secondary",
  children: "Learn more"
}, "unlinkdata_link")];
const unlinkSteps = [
  {
    order: 1,
    title: "Unlinking wallet will do the following:",
    content: /* @__PURE__ */ jsx(ListGroup, {
      children: unlinkData.map((data, i) => /* @__PURE__ */ jsx(ListGroupItem, {
        icon: /* @__PURE__ */ jsx(ReactComponent, {}),
        content: data
      }, `unlinkData_${i}`))
    })
  },
  {
    order: 2,
    title: "",
    content: /* @__PURE__ */ jsxs("div", {
      className: "flex flex-col justify-center items-center font-akkurat-bold font-base mb-8",
      children: [/* @__PURE__ */ jsx("div", {
        className: "mb-2",
        children: /* @__PURE__ */ jsx(ReactComponent$1, {})
      }), "Your Wallet has been successfully unlinked."]
    })
  }
];
const MAINNET_CHAINID = 1;
const initializeETHConnector = (id) => {
  if (id === walletId.metamask) {
    return initializeConnector((actions) => new MetaMask(actions));
  } else if (id === walletId.walletconnect) {
    return initializeConnector((actions) => new WalletConnect(actions, {
      rpc: URLS
    }), Object.keys(URLS).map((chainId) => Number(chainId)));
  } else {
    return [];
  }
};
const getETHAccount = (account, ENSName) => {
  if (account === void 0)
    return "";
  return ENSName || account;
};
const connectETHWallet = (connector) => {
  if (connector instanceof WalletConnect || connector instanceof Network) {
    connector.activate(MAINNET_CHAINID);
  } else {
    connector.activate(getAddChainParameters(MAINNET_CHAINID));
  }
};
const MetaMaskCard = ({
  id,
  connector,
  hooks,
  onSignMessage
}) => {
  const {
    isUserConsent
  } = useUser();
  const {
    isFirstStep,
    goNext
  } = useSteps();
  const {
    track
  } = useAnalytics();
  const {
    useAccount,
    useError,
    useIsActive,
    useIsActivating,
    useProvider,
    useENSName
  } = hooks;
  const account = useAccount();
  const error = useError();
  const isActive = useIsActive();
  const isActivating = useIsActivating();
  const provider = useProvider();
  const ENSName = useENSName(provider);
  const signer = provider == null ? void 0 : provider.getSigner();
  const handleClick = () => {
    if (isActivating)
      return;
    if (isFirstStep) {
      goNext();
      track(trackingEvents.LINK_WALLET_CONNECTOR_BTN_PRESSED(id));
    }
    if (account) {
      handleSign();
    } else {
      connectETHWallet(connector);
    }
  };
  const handleSign = useCallback(() => {
    if (!isUserConsent || !isActive || !signer)
      return;
    const newAccount = getETHAccount(account, ENSName);
    onSignMessage(newAccount || "", signer);
  }, [ENSName, account, isActive, isUserConsent, onSignMessage, signer]);
  useEffect(() => {
    if (isActive) {
      handleSign();
    }
  }, [isActive]);
  const hasUserRejectedRequest = (error == null ? void 0 : error.message) === "User rejected the request.";
  const hasUserClosedModal = (error == null ? void 0 : error.message) == "User closed modal";
  const displayError = error !== void 0 && !hasUserRejectedRequest && !hasUserClosedModal;
  const errorMsg = displayError ? (error == null ? void 0 : error.message) || "" : "";
  useEffect(() => {
    void connector.connectEagerly().catch(() => {
      console.debug(`Failed to connect eagerly to ${id}`);
    }).then(() => {
      console.debug(`'Successfully connected eagerly to ${id}`);
      void connector.deactivate();
    });
  }, [connector, id]);
  return /* @__PURE__ */ jsx(LinkWalletBtn, {
    id,
    isLoading: isActivating,
    onClick: handleClick,
    disabled: !isUserConsent,
    errorMsg
  });
};
var global = "";
const [metamaskConnector, metamaskHooks] = initializeETHConnector(walletId.metamask);
const [walletconnectConnector, walletconnectHooks] = initializeETHConnector(walletId.walletconnect);
const WalletLinkModal = ({
  message,
  isLinking,
  isWalletLinked,
  errorMsg,
  settingsLink,
  customInitButton,
  customSettingsButton,
  eventTracker,
  onLinkWallet,
  onClose
}) => {
  const {
    isUserConsent
  } = useUser();
  const {
    address,
    saveAddress
  } = useWallet();
  const {
    showModal,
    toggleModal
  } = useModal();
  const {
    currStep,
    isFirstStep,
    isLastStep,
    goBack,
    goToLastStep
  } = useSteps();
  const {
    resetContextState
  } = useOtherContext();
  const {
    track,
    setAnalytics
  } = useAnalytics();
  const [signData, signMessage, resetSignState] = useSignMessage();
  const InitButton = () => customInitButton ? React__default.cloneElement(customInitButton, {
    onClick: handleOpenModal
  }) : /* @__PURE__ */ jsx(Button, {
    variant: "primary",
    onClick: handleOpenModal,
    children: "Link Non-Custodial Wallet"
  });
  const handleOpenModal = () => {
    toggleModal();
    track(trackingEvents.LINK_WALLET_BTN_PRESSED);
    track(trackingEvents.LINK_WALLET_MODAL_VIEWED);
  };
  const handleCloseModal = () => {
    if (!showModal)
      return;
    resetContextState();
    resetSignState();
    onClose();
    if (isLastStep) {
      track(trackingEvents.LINK_WALLET_MODAL_SUCCESS_DIMISSED);
    }
  };
  const handleSignMessage = (account, signer) => {
    if (!isUserConsent)
      return;
    saveAddress(account);
    const canSignMessage = signer !== void 0 && !signData.hasSigned;
    if (canSignMessage) {
      signMessage(message, signer, account);
    }
  };
  const handleClickSettingsLink = () => {
    track(trackingEvents.LINK_WALLET_MODAL_SUCCESS_CTA_PRESSED);
  };
  useEffect(() => {
    if (signData.signature && address) {
      const data = {
        address,
        chainId: MAINNET_CHAINID,
        message,
        signature: signData.signature
      };
      onLinkWallet(data);
    }
  }, [address, message, signData.signature]);
  useEffect(() => {
    if (isWalletLinked) {
      goToLastStep();
      track(trackingEvents.LINK_WALLET_MODAL_SUCCESS_VIEWED);
    }
  }, [isWalletLinked]);
  useEffect(() => {
    if (eventTracker) {
      setAnalytics(eventTracker);
    }
  }, [eventTracker]);
  const displayError = errorMsg !== void 0 || signData.error !== void 0 && signData.error.code !== 4001;
  const errorMessage = errorMsg || GENERIC_ERROR_MSG;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(InitButton, {}), showModal && /* @__PURE__ */ jsx(Modal, {
      show: showModal,
      onClickOutside: handleCloseModal,
      children: isLinking && !isWalletLinked ? /* @__PURE__ */ jsx("div", {
        className: "py-8",
        children: "Linking your wallet..."
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ModalHeader, {
          onClose: handleCloseModal,
          onBack: goBack,
          hideBackBtn: isFirstStep || isLastStep,
          children: currStep.title
        }), /* @__PURE__ */ jsx(ModalBody, {
          children: currStep.content
        }), /* @__PURE__ */ jsx("div", {
          className: "mb-3"
        }), /* @__PURE__ */ jsx(ModalFooter, {
          children: isLastStep ? settingsLink && /* @__PURE__ */ jsx("div", {
            className: "text-center py-3",
            children: /* @__PURE__ */ jsx(ExternalLink, {
              url: settingsLink,
              onClick: handleClickSettingsLink,
              children: customSettingsButton || /* @__PURE__ */ jsx(Button, {
                variant: "primary",
                children: "View linked wallets"
              })
            })
          }) : /* @__PURE__ */ jsxs("div", {
            className: "grid gap-3",
            children: [displayError && /* @__PURE__ */ jsx(ErrorMessage, {
              message: errorMessage
            }), /* @__PURE__ */ jsx(MetaMaskCard, {
              id: walletId.metamask,
              connector: metamaskConnector,
              hooks: metamaskHooks,
              onSignMessage: handleSignMessage
            }), /* @__PURE__ */ jsx(MetaMaskCard, {
              id: walletId.walletconnect,
              connector: walletconnectConnector,
              hooks: walletconnectHooks,
              onSignMessage: handleSignMessage
            })]
          })
        }), /* @__PURE__ */ jsx("div", {
          className: "mb-4"
        })]
      })
    })]
  });
};
const WalletUnlinkModal = ({
  errorMsg,
  isUnlinking,
  isWalletUnlinked,
  customInitButton,
  customConfirmButton,
  customCancelButton,
  eventTracker,
  onUnlinkWallet,
  onClose
}) => {
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal(!showModal);
  const InitButton = () => customInitButton ? React__default.cloneElement(customInitButton, {
    onClick: handleOpenModal
  }) : /* @__PURE__ */ jsx(Button, {
    variant: "primary",
    onClick: handleOpenModal,
    children: "Unlink Wallet"
  });
  const ConfirmButton = () => customConfirmButton ? React__default.cloneElement(customConfirmButton, {
    onClick: handleUnlinkWallet
  }) : /* @__PURE__ */ jsx(Button, {
    variant: "primary",
    onClick: handleUnlinkWallet,
    children: "Unlink Wallet"
  });
  const CancelButton = () => customCancelButton ? React__default.cloneElement(customCancelButton, {
    onClick: handleCancelUnlinkWallet
  }) : /* @__PURE__ */ jsx(Button, {
    variant: "light",
    onClick: handleCancelUnlinkWallet,
    children: "Cancel"
  });
  const track = (eventName) => {
    if (!eventTracker)
      return;
    return eventTracker.track(eventName);
  };
  const handleOpenModal = () => {
    toggleModal();
    track(trackingEvents.UNLINK_WALLET_BTN_PRESSED);
    track(trackingEvents.UNLINK_WALLET_MODAL_VIEWED);
  };
  const handleUnlinkWallet = () => {
    onUnlinkWallet();
    track(trackingEvents.UNLINK_WALLET_MODAL_CONFIRM_CTA_PRESSED);
  };
  const handleCancelUnlinkWallet = () => {
    handleCloseModal();
    track(trackingEvents.UNLINK_WALLET_MODAL_CANCEL_CTA_PRESSED);
  };
  const handleCloseModal = () => {
    if (!showModal)
      return;
    toggleModal();
    onClose();
    track(trackingEvents.UNLINK_WALLET_MODAL_DISMISSED);
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(InitButton, {}), showModal && /* @__PURE__ */ jsx(Modal, {
      show: showModal,
      onClickOutside: handleCloseModal,
      children: isUnlinking ? /* @__PURE__ */ jsx("div", {
        className: "py-8",
        children: "Unlinking your wallet..."
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(ModalHeader, {
          onClose: handleCloseModal,
          hideBackBtn: true,
          children: !isWalletUnlinked && unlinkSteps[0].title
        }), /* @__PURE__ */ jsx(ModalBody, {
          children: isWalletUnlinked ? unlinkSteps[1].content : /* @__PURE__ */ jsxs("div", {
            className: "mb-4",
            children: [unlinkSteps[0].content, errorMsg && /* @__PURE__ */ jsx(ErrorMessage, {
              message: errorMsg
            })]
          })
        }), /* @__PURE__ */ jsx(ModalFooter, {
          children: !isWalletUnlinked && /* @__PURE__ */ jsxs("div", {
            className: "flex justify-end mb-3",
            children: [/* @__PURE__ */ jsx(CancelButton, {}), /* @__PURE__ */ jsx(ConfirmButton, {})]
          })
        })]
      })
    })]
  });
};
const WalletLinkContext = React__default.createContext(null);
WalletLinkContext.displayName = "WalletLinkContext";
const WalletLinkProvider = ({
  children
}) => {
  const [isUserConsent, setIsUserConsent] = useState(false);
  const toggleUserConsent = () => setIsUserConsent(!isUserConsent);
  const [address, setAddress] = useState("");
  const saveAddress = (newAddress) => setAddress(newAddress);
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal(!showModal);
  const [currStepIndex, setCurrStepIndex] = useState(0);
  const [analytics, setAnalytics] = useState(null);
  const goBack = () => {
    if (currStepIndex === 0)
      return;
    const newStep = currStepIndex - 1;
    setCurrStepIndex(newStep);
  };
  const goNext = () => {
    if (currStepIndex === steps.length - 1)
      return;
    const newStep = currStepIndex + 1;
    setCurrStepIndex(newStep);
  };
  const goToStep = (stepIndex) => {
    if (stepIndex < 0 || stepIndex > steps.length - 1)
      return;
    setCurrStepIndex(stepIndex);
  };
  const resetContextState = () => {
    setIsUserConsent(false);
    setAddress("");
    setShowModal(false);
    setCurrStepIndex(0);
  };
  return /* @__PURE__ */ jsx(WalletLinkContext.Provider, {
    value: {
      isUserConsent,
      toggleUserConsent,
      address,
      saveAddress,
      showModal,
      toggleModal,
      currStepIndex,
      goBack,
      goNext,
      goToStep,
      resetContextState,
      analytics,
      setAnalytics
    },
    children
  });
};
const useWalletLinkContext = () => {
  const context = useContext(WalletLinkContext);
  if (context === null) {
    throw new Error("Must be used within a Provider");
  }
  return context;
};
const useUser = () => {
  const {
    isUserConsent,
    toggleUserConsent
  } = useWalletLinkContext();
  return {
    isUserConsent,
    toggleUserConsent
  };
};
const useWallet = () => {
  const {
    address,
    saveAddress
  } = useWalletLinkContext();
  return {
    address,
    saveAddress
  };
};
const useModal = () => {
  const {
    showModal,
    toggleModal
  } = useWalletLinkContext();
  return {
    showModal,
    toggleModal
  };
};
const useSteps = () => {
  const {
    currStepIndex,
    goBack,
    goNext,
    goToStep
  } = useWalletLinkContext();
  const currStep = steps[currStepIndex];
  const isFirstStep = currStepIndex === 0;
  const isLastStep = currStepIndex === steps.length - 1;
  const goToFirstStep = () => goToStep(0);
  const goToLastStep = () => goToStep(steps.length - 1);
  return {
    currStepIndex,
    currStep,
    isFirstStep,
    isLastStep,
    goBack,
    goNext,
    goToFirstStep,
    goToLastStep,
    goToStep
  };
};
const useAnalytics = () => {
  const {
    analytics,
    setAnalytics
  } = useWalletLinkContext();
  const track = (eventName) => {
    if (!analytics)
      return;
    analytics.track(eventName);
  };
  return {
    analytics,
    track,
    setAnalytics
  };
};
const useOtherContext = () => {
  const {
    resetContextState
  } = useWalletLinkContext();
  return {
    resetContextState
  };
};
export { Button, Chain, ErrorMessage, ExternalLink, InfoBox, LinkWalletBtn, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader, SettingGroup, SettingGroupItem, Spinner, WalletLinkModal, WalletLinkProvider, WalletUnlinkModal, useOnClickOutside, useSignMessage };
//# sourceMappingURL=index.es.js.map
